import React, { useState, useEffect } from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Navigate } from 'react-router-dom';
import { 
  Container, 
  Box, 
  Typography, 
  Button, 
  Paper, 
  CircularProgress,
  useMediaQuery,
  useTheme
} from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const isAuthenticated = useIsAuthenticated();
  const { login, isLoading } = useAuth();
  const { inProgress, accounts } = useMsal();
  const [waitingForAuth, setWaitingForAuth] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  useEffect(() => {
    // Force a longer wait for auth to initialize fully
    const timer = setTimeout(() => {
      setWaitingForAuth(false);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);
  
  console.log('Login page - auth state:', { 
    isAuthenticated, 
    isLoading, 
    inProgress, 
    waitingForAuth,
    hasAccounts: accounts.length > 0 
  });

  // Show loading if authentication is in progress
  if (isLoading || waitingForAuth || inProgress !== "none") {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // Redirect to home if already authenticated or if accounts exist
  if (isAuthenticated || accounts.length > 0) {
    console.log('Already authenticated or accounts exist, redirecting to home...');
    return <Navigate to="/" />;
  }

  return (
    <Container maxWidth="sm" sx={{ px: { xs: 2, sm: 3 } }}>
      <Box 
        sx={{ 
          mt: { xs: 4, sm: 8 }, 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center' 
        }}
      >
        <Paper 
          elevation={3} 
          sx={{ 
            p: { xs: 3, sm: 4 }, 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            width: '100%',
            borderRadius: { xs: 1, sm: 2 }
          }}
        >
          <Typography 
            component="h1" 
            variant={isMobile ? "h5" : "h4"} 
            gutterBottom
            align="center"
          >
            Deposition Summaries
          </Typography>
          
          <Typography 
            variant={isMobile ? "body2" : "body1"} 
            align="center" 
            color="textSecondary" 
            paragraph
            sx={{ mb: { xs: 2, sm: 3 } }}
          >
            Login to access deposition summarization tools
          </Typography>
          
          <Button
            variant="contained"
            color="primary"
            size={isMobile ? "medium" : "large"}
            fullWidth={isMobile}
            startIcon={<LoginIcon />}
            onClick={login}
            sx={{ 
              mt: { xs: 1, sm: 2 },
              py: { xs: 1.5, sm: 1 }
            }}
          >
            Sign In with Microsoft
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;